/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:696d2ff2-ff99-431e-8c48-e5322928debc",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_tGSX8cllG",
    "aws_user_pools_web_client_id": "4qjf7fufqf2ahq7ece0lkf2duf",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_appsync_graphqlEndpoint": "https://qt2it6sbmfdjnb2qjcpvzoklda.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-3h7res43wbdtdkzr4zdcsdrmdi",
    "aws_user_files_s3_bucket": "tripwardrobe-storage192857-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
